import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useLenis } from "@/hooks/useLenis";
import { Toaster } from "@/components/ui/sonner";
import { CartProvider } from "@/context/CartContext";
import { WishlistProvider } from "@/context/WishlistContext";
import Home from "@/pages/Home";
import Vanities from "@/pages/Vanities";
import ProductDetail from "@/pages/ProductDetail";
import Cart from "@/pages/Cart";
import Checkout from "@/pages/Checkout";
import Wishlist from "@/pages/Wishlist";
import OrderConfirmation from "@/pages/OrderConfirmation";
import OrderHistory from "@/pages/OrderHistory";
import OrderDetail from "@/pages/OrderDetail";
import ScrollToTop from "@/components/ScrollToTop";

function App() {
  useLenis();

  return (
    <div className="app-root grain" data-testid="bathlane-app">
      <CartProvider>
        <WishlistProvider>
          <BrowserRouter>
            <ScrollToTop />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/vanities" element={<Vanities />} />
              <Route path="/vanities/:id" element={<ProductDetail />} />
              <Route path="/cart" element={<Cart />} />
              <Route path="/checkout" element={<Checkout />} />
              <Route path="/order/confirmed" element={<OrderConfirmation />} />
              <Route path="/orders" element={<OrderHistory />} />
              <Route path="/orders/:orderId" element={<OrderDetail />} />
              <Route path="/wishlist" element={<Wishlist />} />
            </Routes>
          </BrowserRouter>
          <Toaster theme="light" position="bottom-center" />
        </WishlistProvider>
      </CartProvider>
    </div>
  );
}

export default App;

